/* Brand posters — one per page (user-specified mapping) */
export const POSTER_P1_LANDING = "https://customer-assets-lxgj4vgw.emergentagent.net/job_review-patterns/artifacts/i95kkkn8_Screenshot_20260705_140157_ChatGPT.jpg";
export const POSTER_P2_SEARCH = "https://customer-assets-lxgj4vgw.emergentagent.net/job_review-patterns/artifacts/52rcwvd2_file_0000000026d881f5a22e54cef6b33ada.png";
export const POSTER_P3_SKINNY = "https://customer-assets-lxgj4vgw.emergentagent.net/job_review-patterns/artifacts/s1hxwntt_file_00000000c94881fdb24c8609280d2580.png";
export const POSTER_P4_ZODIAC = "https://customer-assets-lxgj4vgw.emergentagent.net/job_review-patterns/artifacts/zd3ndcm6_Screenshot_20260709_083722_ChatGPT.jpg";
export const POSTER_P5_REVIEW = "https://customer-assets-lxgj4vgw.emergentagent.net/job_review-patterns/artifacts/jo81cu39_Screenshot_20260711_065834_Gallery.jpg";

/**
 * Signature Welp background: brand poster softened into an ambient texture
 * (cream wash + heavy blur) so the interface always stays the focus.
 */
export default function PageBg({ children, poster = POSTER_P1_LANDING, scrim, contentClassName = "" }) {
  return (
    <div className={`relative min-h-screen w-full overflow-x-hidden bg-[#FDF4FA] text-[#1A1A1A] ${contentClassName}`}>
      <div aria-hidden className="fixed inset-0 z-0 pointer-events-none bg-cover bg-center"
           style={{ backgroundImage: `url(${poster})` }} />
      <div aria-hidden className="fixed inset-0 z-0 pointer-events-none bg-[#FFFBF5]/40 backdrop-blur-[2px]" />
      <div className="relative z-10">{children}</div>
    </div>
  );
}
